import * as React from "react";
import Snackbar from "@mui/material/Snackbar";
// import MuiAlert from "@mui/material/Alert";

import { useSelector, useDispatch } from "react-redux";
import { Alert } from "@mui/material";
import {
  errorColor,
  getErrorMessage,
  isError,
  removeError,
} from "../redux/slices/errorSlice";

import { useAppDispatch, useAppSelector } from "../hooks/reduxhook";

export default function SnackbarError() {
  const dispatch = useAppDispatch();
  const showError = useAppSelector(isError);

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(removeError());
  };

  return (
    <Snackbar open={showError} autoHideDuration={6000} onClose={handleClose}>
      <Alert onClose={handleClose} severity="error" sx={{ width: "100%" }}>
        {useAppSelector(getErrorMessage)}
      </Alert>
    </Snackbar>
  );
}
